<template>
  <div class="auth-wrapper auth-v2 hdg-login">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo hdg-login__brand">
        <b-img
          :src="brandLogo"
          alt="HUAYDRAGON"
          class="hdg-login__brand-img"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Brand visual-->
      <b-col
        lg="8"
        class="hdg-login__visual d-none d-lg-flex"
      >
        <div class="hdg-login__visual-inner">
          <div
            class="hdg-login__hero-panel"
            aria-hidden="true"
          >
            <div class="hdg-login__hero-toolbar">
              <span class="hdg-login__hero-status">
                <span />
                <span />
                <span />
              </span>
              <span class="hdg-login__hero-line" />
              <span class="hdg-login__hero-line" />
              <span class="hdg-login__hero-dot" />
            </div>
            <div class="hdg-login__hero-metrics">
              <span
                v-for="index in 4"
                :key="`metric-${index}`"
              >
                <i />
                <b />
              </span>
            </div>
            <div class="hdg-login__hero-chart">
              <span
                v-for="index in 14"
                :key="`bar-${index}`"
              />
            </div>
            <div class="hdg-login__hero-table">
              <span
                v-for="index in 28"
                :key="`cell-${index}`"
              />
            </div>
          </div>
        </div>
      </b-col>
      <!-- /Brand visual-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg hdg-login__form-wrap px-2 p-lg-5"
      >
        <b-col
          :sm="authStage === 'credentials' ? 8 : 10"
          :md="authStage === 'credentials' ? 6 : 8"
          lg="12"
          class="hdg-login__form px-xl-2 mx-auto"
          :class="{ 'hdg-login__form--totp': authStage !== 'credentials' }"
        >
          <b-img
            :src="brandLogo"
            alt="HUAYDRAGON"
            class="hdg-login__form-logo d-lg-none"
          />
          <div class="hdg-login__stage-header">
            <span class="hdg-login__stage-icon">
              <feather-icon :icon="authIcon" />
            </span>
            <div class="hdg-login__stage-copy">
              <b-card-title
                class="hdg-login__title hdg-login__title--stage font-weight-bold"
                title-tag="h2"
              >
                {{ authTitle }}
              </b-card-title>
              <p class="hdg-login__subtitle">
                {{ authDescription }}
              </p>
            </div>
          </div>

          <!--          <b-alert-->
          <!--            variant="primary"-->
          <!--            show-->
          <!--          >-->
          <!--            <div class="alert-body font-small-2">-->
          <!--              <p>-->
          <!--                <small class="mr-50"><span class="font-weight-bold">Admin:</span> admin@demo.com | admin</small>-->
          <!--              </p>-->
          <!--              <p>-->
          <!--                <small class="mr-50"><span class="font-weight-bold">Client:</span> client@demo.com | client</small>-->
          <!--              </p>-->
          <!--            </div>-->
          <!--            <feather-icon-->
          <!--              v-b-tooltip.hover.left="'This is just for ACL demo purpose'"-->
          <!--              icon="HelpCircleIcon"-->
          <!--              size="18"-->
          <!--              class="position-absolute"-->
          <!--              style="top: 10; right: 10;"-->
          <!--            />-->
          <!--          </b-alert>-->

          <!-- form -->
          <validation-observer
            v-if="authStage === 'credentials'"
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- username -->
              <b-form-group
                :label="$t('Username')"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Username')"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="login-username"
                    :placeholder="$t('Username')"
                    @input="onUsernameChanged"
                    @blur="clearError"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group
                :label="$t('Password')"
                label-for="login-password"
              >
                <!--                <div class="d-flex justify-content-between">-->
                <!--                  <label for="login-password">Password</label>-->
                <!--                  <b-link :to="{name:'auth-forgot-password'}">-->
                <!--                    <small>Forgot Password?</small>-->
                <!--                  </b-link>-->
                <!--                </div>-->
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Password')"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      :placeholder="$t('Password')"
                      @input="clearError"
                      @blur="clearError"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                v-if="captchaRequired"
                :label="$t('Verify identity')"
                label-for="login-captcha"
              >
                <div
                  v-if="captcha && captcha.provider === 'selfhost'"
                  class="hdg-login__captcha"
                >
                  <div class="hdg-login__captcha-image">
                    <img
                      :src="captcha.imageDataUrl"
                      alt="captcha"
                    >
                  </div>
                  <b-button
                    type="button"
                    size="sm"
                    variant="outline-primary"
                    :disabled="captchaLoading"
                    @click="refreshCaptcha"
                  >
                    {{ $t('Change image') }}
                  </b-button>
                </div>
                <b-form-input
                  id="login-captcha"
                  v-model="captchaAnswer"
                  name="login-captcha"
                  inputmode="numeric"
                  maxlength="6"
                  autocomplete="off"
                  :placeholder="$t('Enter the numbers in the image')"
                  @input="clearCaptchaError"
                />
                <small
                  v-if="captchaError"
                  class="text-danger"
                >{{ captchaError }}</small>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid || isSubmitting || (captchaRequired && !captchaAnswer)"
              >
                {{ $t('Sign in') }}
              </b-button>
            </b-form>
          </validation-observer>

          <div
            v-else
            class="hdg-login__totp"
          >
            <div
              v-if="totpSetupRequired"
              class="hdg-login__totp-setup"
            >
              <div
                v-if="totpQrDataUri"
                class="hdg-login__totp-qr"
              >
                <div class="hdg-login__totp-qr-frame">
                  <img
                    :src="totpQrDataUri"
                    :alt="$t('Two-factor authentication QR code')"
                  >
                </div>
                <small>{{ $t('Scan with an authentication app that supports 6-digit codes') }}</small>
              </div>
              <div class="hdg-login__totp-actions">
                <a
                  v-if="totpOtpAuthUri"
                  class="btn btn-outline-primary btn-sm"
                  :href="totpOtpAuthUri"
                >
                  {{ $t('Open in authentication app') }}
                </a>
                <b-button
                  type="button"
                  size="sm"
                  variant="outline-secondary"
                  @click="copyTotpManualKey"
                >
                  {{ $t('Copy setup key') }}
                </b-button>
              </div>
              <div class="hdg-login__totp-key">
                <span>{{ $t('Setup key') }}</span>
                <code ref="totpManualKeyBox">
                  <span
                    ref="totpManualKeyText"
                    :style="totpManualKeyStyle"
                  >{{ formattedTotpManualKey }}</span>
                </code>
              </div>
            </div>

            <div class="hdg-login__otp-inputs">
              <b-form-input
                v-for="(_, index) in totpDigits"
                :key="`totp-${index}`"
                ref="totpDigit"
                :value="totpDigits[index]"
                maxlength="1"
                inputmode="numeric"
                autocomplete="one-time-code"
                class="hdg-login__otp-input"
                :disabled="totpLoading || totpReplayCountdownSeconds > 0"
                @input="value => onTotpDigitInput(value, index)"
                @keydown="onTotpDigitKeydown"
                @keydown.backspace="onTotpDigitBackspace(index)"
                @paste.prevent="onTotpPaste"
              />
            </div>
            <small
              v-if="totpError"
              class="text-danger d-block mt-1"
            >{{ totpError }}</small>
            <small
              v-if="totpReplayCountdownSeconds > 0"
              class="text-warning d-block mt-50"
            >
              {{ $t('Please wait for the next code in {seconds} seconds', { seconds: totpReplayCountdownSeconds }) }}
            </small>

            <b-button
              type="button"
              variant="primary"
              block
              class="mt-2"
              :disabled="totpLoading || !isTotpComplete || totpReplayCountdownSeconds > 0"
              @click="verifyTotp"
            >
              {{ $t('Confirm') }}
            </b-button>
            <b-button
              type="button"
              variant="flat-secondary"
              block
              class="mt-50"
              :disabled="totpLoading"
              @click="backToCredentials"
            >
              {{ $t('Back to sign in') }}
            </b-button>
          </div>

          <!--          <b-card-text class="text-center mt-2">-->
          <!--            <span>New on our platform? </span>-->
          <!--            <b-link :to="{name:'auth-register'}">-->
          <!--              <span>&nbsp;Create an account</span>-->
          <!--            </b-link>-->
          <!--          </b-card-text>-->

          <!-- divider -->
          <!--          <div class="divider my-2">-->
          <!--            <div class="divider-text">-->
          <!--              or-->
          <!--            </div>-->
          <!--          </div>-->

          <!-- social buttons -->
          <!--          <div class="auth-footer-btn d-flex justify-content-center">-->
          <!--            <b-button-->
          <!--              variant="facebook"-->
          <!--              href="javascript:void(0)"-->
          <!--            >-->
          <!--              <feather-icon icon="FacebookIcon" />-->
          <!--            </b-button>-->
          <!--            <b-button-->
          <!--              variant="twitter"-->
          <!--              href="javascript:void(0)"-->
          <!--            >-->
          <!--              <feather-icon icon="TwitterIcon" />-->
          <!--            </b-button>-->
          <!--            <b-button-->
          <!--              variant="google"-->
          <!--              href="javascript:void(0)"-->
          <!--            >-->
          <!--              <feather-icon icon="MailIcon" />-->
          <!--            </b-button>-->
          <!--            <b-button-->
          <!--              variant="github"-->
          <!--              href="javascript:void(0)"-->
          <!--            >-->
          <!--              <feather-icon icon="GithubIcon" />-->
          <!--            </b-button>-->
          <!--          </div>-->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardTitle,
  BImg,
  BForm,
  BButton, /* BAlert, */
  VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { getFirstPageForLoggedInUser } from '@/auth/utils'
import generateQrCodeDataUri from '@core/utils/qrCode'
import { startSessionManager } from '@core/auth/session/sessionManager'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    // BAlert,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      password: '',
      username: '',
      captchaRequired: false,
      captcha: null,
      captchaAnswer: '',
      captchaError: '',
      captchaLoading: false,
      isSubmitting: false,
      authStage: 'credentials',
      totpSetupRequired: false,
      totpChallengeId: '',
      totpManualKey: '',
      totpOtpAuthUri: '',
      totpDigits: ['', '', '', '', '', ''],
      totpError: '',
      totpLoading: false,
      totpManualKeyFontSize: 1,
      totpAutoSubmitTimer: null,
      totpReplayCountdownSeconds: 0,
      totpReplayCountdownUntil: 0,
      totpReplayCountdownTimer: null,

      // validation rules
      required,
      email,
    }
  },
  computed: {
    isDarkSkin() {
      return this.$store.state.appConfig.layout.skin === 'dark'
    },
    brandLogo() {
      if (this.isDarkSkin) return require('@/assets/images/logo/huaydragon-logo-dark.png')
      return require('@/assets/images/logo/huaydragon-logo.png')
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    authTitle() {
      if (this.authStage === 'credentials') return this.$t('Agent Login')
      return this.$t('Two-factor authentication')
    },
    authIcon() {
      if (this.authStage === 'credentials') return 'UserIcon'
      return 'ShieldIcon'
    },
    authDescription() {
      if (this.authStage === 'credentials') return this.$t('Sign in to continue')
      return this.totpStageDescription
    },
    totpStageDescription() {
      return this.totpSetupRequired
        ? this.$t('Set it up before signing in')
        : this.$t('Enter the 6-digit code from your authentication app')
    },
    totpCode() {
      return this.totpDigits.join('')
    },
    isTotpComplete() {
      return this.totpCode.length === 6
    },
    formattedTotpManualKey() {
      return `${this.totpManualKey || ''}`.trim()
    },
    totpQrDataUri() {
      if (!this.totpOtpAuthUri) return ''
      try {
        return generateQrCodeDataUri(this.totpOtpAuthUri)
      } catch (error) {
        return ''
      }
    },
    totpManualKeyStyle() {
      return {
        fontSize: `${this.totpManualKeyFontSize}rem`,
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.fitTotpManualKey)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fitTotpManualKey)
    this.clearTotpAutoSubmit()
    this.clearTotpReplayCountdown()
  },
  methods: {
    login() {
      this.$refs.loginForm.validate()
        .then(success => {
          if (success) {
            if (this.captchaRequired && !this.captchaAnswer) {
              this.captchaError = this.$t('Please enter the verification numbers')
              return
            }
            this.isSubmitting = true
            const loginPayload = {
              username: this.username,
              password: this.password,
            }
            if (this.captchaRequired) {
              loginPayload.captcha = {
                provider: this.captcha ? this.captcha.provider : null,
                challengeId: this.captcha ? this.captcha.challengeId : null,
                answer: this.captchaAnswer,
              }
            }
            useJwt.login(loginPayload)
              .then(response => {
                this.resetCaptcha()
                if (response.data && response.data.totpRequired) {
                  this.handleTotpChallenge(response.data)
                  return
                }
                this.completeLogin(response.data)
              })
              .catch(error => {
                const response = error.response
                if (!response) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Error',
                      icon: 'AlertCircleIcon',
                      variant: 'danger',
                      text: this.$t('Something wrong'),
                    },
                  })
                  return
                }

                const { status, data } = response
                this.applyCaptchaResponse(data)
                if (status === 429) {
                  if (data && data.error && typeof data.error !== 'string') {
                    const formErrors = {}
                    if (data.error.username) formErrors.username = this.translateMessage(data.error.username)
                    if (data.error.password) formErrors.password = this.translateMessage(data.error.password)
                    if (Object.keys(formErrors).length > 0) this.$refs.loginForm.setErrors(formErrors)
                    if (data.error.captcha) this.captchaError = this.translateMessage(data.error.captcha)
                  }

                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: this.$t('Please wait a moment'),
                      icon: 'ClockIcon',
                      variant: 'warning',
                      text: this.getCooldownMessage(data),
                    },
                  })
                  return
                }

                if (data && data.error) {
                  const formErrors = {}
                  if (typeof data.error === 'string') {
                    this.showErrorToast(data.error)
                  } else {
                    if (data.error.username) formErrors.username = this.translateMessage(data.error.username)
                    if (data.error.password) formErrors.password = this.translateMessage(data.error.password)
                    if (Object.keys(formErrors).length > 0) this.$refs.loginForm.setErrors(formErrors)
                    if (data.error.captcha) this.captchaError = this.translateMessage(data.error.captcha)
                    if (
                      Object.keys(formErrors).length === 0
                      && !data.error.captcha
                      && (data.error.message || data.error.title)
                    ) {
                      this.showErrorToast(data.error.message || data.error.title)
                    }
                  }
                } else {
                  this.showErrorToast(this.getErrorMessage(data))
                }

              })
              .finally(() => {
                this.isSubmitting = false
              })
          }
        })
    },
    completeLogin(data) {
      const { userData } = data
      userData.ability = userData.ability || []
      userData.ability.push({
        action: 'read',
        subject: 'Auth',
      })
      useJwt.setToken(data.accessToken)
      useJwt.setRefreshToken(data.refreshToken)
      localStorage.setItem('userData', JSON.stringify(userData))
      this.$store.commit('app/UPDATE_USER_DATA', userData)
      this.$ability.update(userData.ability)
      startSessionManager()

      return this.$router.replace(getFirstPageForLoggedInUser())
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Welcome ${userData.fullName || userData.username}`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `You have successfully logged in as ${userData.role}.`,
            },
          })
        })
    },
    handleTotpChallenge(data) {
      this.clearTotpAutoSubmit()
      this.clearTotpReplayCountdown()
      this.authStage = data.totpSetupRequired ? 'totp-setup' : 'totp-verify'
      this.totpSetupRequired = !!data.totpSetupRequired
      this.totpChallengeId = data.challengeId || ''
      this.totpManualKey = data.manualKey || ''
      this.totpOtpAuthUri = data.otpauthUri || ''
      this.totpDigits = ['', '', '', '', '', '']
      this.totpError = ''
      this.totpManualKeyFontSize = 1
      this.$nextTick(() => {
        this.focusTotpDigit(0)
        window.requestAnimationFrame(() => this.fitTotpManualKey())
      })
    },
    async verifyTotp() {
      this.clearTotpAutoSubmit()
      if (!this.isTotpComplete) {
        this.totpError = this.$t('Please enter a 6-digit verification code')
        return
      }

      this.totpLoading = true
      this.totpError = ''
      try {
        const response = await useJwt.loginTotp({
          challengeId: this.totpChallengeId,
          code: this.totpCode,
        })
        await this.completeLogin(response.data)
      } catch (error) {
        const response = error.response
        const data = response && response.data
        const code = data && data.error && data.error.code
        const message = code
          ? this.translateMessage(code)
          : this.$t('Something wrong')
        this.totpError = message
        this.totpDigits = ['', '', '', '', '', '']
        if (this.isTotpReplayError(code)) {
          this.startTotpReplayCountdown(this.getTotpRetryAfterSeconds(data))
        } else {
          this.clearTotpReplayCountdown()
          this.$nextTick(() => this.focusTotpDigit(0))
        }
        if (response && response.status === 429) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('Please sign in again'),
              icon: 'ClockIcon',
              variant: 'warning',
              text: message,
            },
          })
          this.backToCredentials()
        }
      } finally {
        this.totpLoading = false
      }
    },
    onTotpDigitInput(value, index) {
      if (this.totpReplayCountdownSeconds > 0) return
      this.clearTotpAutoSubmit()
      const digits = `${value || ''}`.replace(/\D/g, '')
      if (digits.length > 1) {
        this.fillTotpDigits(digits, index, 0)
        return
      }

      this.$set(this.totpDigits, index, digits)
      this.totpError = ''
      if (digits && index < this.totpDigits.length - 1) {
        this.focusTotpDigit(index + 1)
      }
      if (this.isTotpComplete) this.scheduleTotpAutoSubmit(200)
    },
    onTotpDigitKeydown(event) {
      if (this.totpReplayCountdownSeconds > 0) {
        event.preventDefault()
        return
      }

      if (event.metaKey || event.ctrlKey) return

      const allowedKeys = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Home',
        'End',
      ]

      if (event.key === 'Enter') {
        if (this.isTotpComplete) {
          event.preventDefault()
          this.verifyTotp()
        }
        return
      }

      if (allowedKeys.includes(event.key)) {
        if (event.key === 'Backspace' || event.key === 'Delete') this.clearTotpAutoSubmit()
        return
      }

      if (/^\d$/.test(event.key)) return
      event.preventDefault()
    },
    onTotpDigitBackspace(index) {
      this.clearTotpAutoSubmit()
      if (this.totpDigits[index] || index === 0) return
      this.focusTotpDigit(index - 1)
    },
    onTotpPaste(event) {
      if (this.totpReplayCountdownSeconds > 0) return
      const text = event.clipboardData ? event.clipboardData.getData('text') : ''
      this.fillTotpDigits(text, 0, 0)
    },
    async copyTotpManualKey() {
      if (!this.totpManualKey) return
      try {
        await navigator.clipboard.writeText(this.totpManualKey)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('Copied'),
            icon: 'CheckIcon',
            variant: 'success',
            text: this.$t('Setup key copied'),
          },
        })
      } catch (error) {
        this.totpError = this.$t('Unable to copy. Please copy from the setup key field')
      }
    },
    fillTotpDigits(value, startIndex, autoSubmitDelay = 200) {
      if (this.totpReplayCountdownSeconds > 0) return
      this.clearTotpAutoSubmit()
      const digits = `${value || ''}`.replace(/\D/g, '').slice(0, 6)
      if (!digits) return
      const next = [...this.totpDigits]
      for (let i = 0; i < digits.length && startIndex + i < next.length; i += 1) {
        next[startIndex + i] = digits[i]
      }
      this.totpDigits = next
      this.totpError = ''
      this.focusTotpDigit(Math.min(startIndex + digits.length, next.length - 1))
      if (next.join('').length === 6) this.scheduleTotpAutoSubmit(autoSubmitDelay)
    },
    focusTotpDigit(index) {
      this.$nextTick(() => {
        const inputs = this.$refs.totpDigit
        if (inputs && inputs[index] && inputs[index].focus) {
          inputs[index].focus()
        }
      })
    },
    backToCredentials() {
      this.resetTotpState()
      this.password = ''
      this.$nextTick(() => {
        if (this.$refs.loginForm) this.$refs.loginForm.reset()
      })
    },
    resetTotpState() {
      this.clearTotpAutoSubmit()
      this.clearTotpReplayCountdown()
      this.authStage = 'credentials'
      this.totpSetupRequired = false
      this.totpChallengeId = ''
      this.totpManualKey = ''
      this.totpOtpAuthUri = ''
      this.totpDigits = ['', '', '', '', '', '']
      this.totpError = ''
      this.totpLoading = false
      this.totpManualKeyFontSize = 1
    },
    scheduleTotpAutoSubmit(delay) {
      this.clearTotpAutoSubmit()
      if (!this.isTotpComplete || this.totpLoading || this.totpReplayCountdownSeconds > 0) return

      this.totpAutoSubmitTimer = window.setTimeout(() => {
        this.totpAutoSubmitTimer = null
        if (this.isTotpComplete && !this.totpLoading && this.totpReplayCountdownSeconds === 0) this.verifyTotp()
      }, delay)
    },
    clearTotpAutoSubmit() {
      if (!this.totpAutoSubmitTimer) return
      window.clearTimeout(this.totpAutoSubmitTimer)
      this.totpAutoSubmitTimer = null
    },
    isTotpReplayError(code) {
      return code === 'รหัสนี้เพิ่งถูกใช้แล้ว กรุณารอรหัสชุดใหม่'
        || code === 'This code was just used. Please wait for the next code'
    },
    startTotpReplayCountdown(retryAfterSeconds = 0) {
      this.clearTotpReplayCountdown()
      const stepMs = 30000
      const now = Date.now()
      this.totpReplayCountdownUntil = retryAfterSeconds > 0
        ? now + retryAfterSeconds * 1000
        : (Math.floor(now / stepMs) + 1) * stepMs
      this.updateTotpReplayCountdown()
      this.totpReplayCountdownTimer = window.setInterval(this.updateTotpReplayCountdown, 250)
    },
    updateTotpReplayCountdown() {
      const seconds = Math.ceil((this.totpReplayCountdownUntil - Date.now()) / 1000)
      if (seconds <= 0) {
        this.clearTotpReplayCountdown()
        this.$nextTick(() => this.focusTotpDigit(0))
        return
      }
      this.totpReplayCountdownSeconds = seconds
    },
    clearTotpReplayCountdown() {
      if (this.totpReplayCountdownTimer) {
        window.clearInterval(this.totpReplayCountdownTimer)
        this.totpReplayCountdownTimer = null
      }
      this.totpReplayCountdownUntil = 0
      this.totpReplayCountdownSeconds = 0
    },
    getTotpRetryAfterSeconds(data) {
      const value = data ? Number(data.retryAfterSeconds) : 0
      return Number.isFinite(value) && value > 0 ? value : 0
    },
    fitTotpManualKey() {
      if (!this.totpManualKey) return
      this.totpManualKeyFontSize = 1
      this.$nextTick(() => {
        const box = this.$refs.totpManualKeyBox
        const text = this.$refs.totpManualKeyText
        if (!box || !text) return

        const style = window.getComputedStyle(box)
        const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
        const availableWidth = box.clientWidth - padding - 2
        const requiredWidth = text.scrollWidth
        if (!availableWidth || !requiredWidth || requiredWidth <= availableWidth) return

        const nextFontSize = Math.max(0.72, Math.floor((availableWidth / requiredWidth) * 100) / 100)
        this.totpManualKeyFontSize = nextFontSize
      })
    },
    async refreshCaptcha() {
      if (!this.username) {
        this.captchaError = this.$t('Please enter username first')
        return
      }
      this.captchaLoading = true
      try {
        const response = await useJwt.loginCaptcha({ username: this.username })
        this.applyCaptchaResponse(response.data)
      } catch (error) {
        const data = error.response && error.response.data
        this.applyCaptchaResponse(data)
        this.captchaError = data && data.error && data.error.captcha
          ? this.translateMessage(data.error.captcha)
          : this.$t('Unable to change verification image. Please try again')
      } finally {
        this.captchaLoading = false
      }
    },
    applyCaptchaResponse(data) {
      if (!data) return
      if (!Object.prototype.hasOwnProperty.call(data, 'captchaRequired')) return
      if (data.captchaRequired && data.captcha) {
        this.captchaRequired = true
        this.captcha = data.captcha
        this.captchaAnswer = ''
        return
      }
      if (data.captchaRequired === false) this.resetCaptcha()
    },
    resetCaptcha() {
      this.captchaRequired = false
      this.captcha = null
      this.captchaAnswer = ''
      this.captchaError = ''
    },
    clearCaptchaError() {
      this.captchaError = ''
    },
    onUsernameChanged() {
      this.resetCaptcha()
      this.resetTotpState()
      this.clearError()
    },
    getErrorMessage(data) {
      if (!data) return this.$t('Something wrong')
      if (typeof data === 'string') return this.translateMessage(data)
      if (data.error && data.error.username) return this.translateMessage(data.error.username)
      if (data.error && data.error.captcha) return this.translateMessage(data.error.captcha)
      return data.message ? this.translateMessage(data.message) : this.$t('Something wrong')
    },
    getCooldownMessage(data) {
      const error = data && data.error
      if (typeof error === 'string') return this.translateMessage(error)
      if (error && (error.message || error.title || error.code)) {
        return this.translateMessage(error.message || error.title || error.code)
      }
      if (!data || !data.retryAfterSeconds) return this.$t('Please try again')
      return this.$t('Please try again in {seconds} seconds', { seconds: data.retryAfterSeconds })
    },
    showErrorToast(text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Error',
          icon: 'AlertCircleIcon',
          variant: 'danger',
          text: this.translateMessage(text),
        },
      })
    },
    translateLoginRole(role) {
      if (!role) return ''
      const roleText = `${role}`
      const key = `loginRoles.${roleText.toLowerCase()}`
      return this.$te(key) ? this.$t(key) : roleText
    },
    translateMessage(text) {
      if (!text) return this.$t('Something wrong')
      const message = `${text}`
      const lockedMatch = message.match(/^.+ถูกล็อกชั่วคราว กรุณาลองใหม่ใน (\d+) วินาที$/)
      if (lockedMatch) {
        return this.$t('The authentication app is temporarily locked. Please try again in {seconds} seconds', {
          seconds: lockedMatch[1],
        })
      }
      return this.$t(message)
    },
    clearError() {
      const usernameErrors = this.$refs.loginForm
        && this.$refs.loginForm.errors
        && this.$refs.loginForm.errors.username
      if (usernameErrors && usernameErrors.length > 0) {
        this.$refs.loginForm.reset()
      }
      this.clearCaptchaError()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.hdg-login {
  position: relative;
  min-height: 100vh;
  background:
    linear-gradient(118deg, rgba(var(--hdg-brand-primary-rgb), 0.055), transparent 46%),
    var(--hdg-surface);
  color: var(--hdg-body);

  .auth-inner {
    overflow-x: hidden;
  }

  &__brand {
    align-items: center;
  }

  &__brand-img {
    display: block;
    width: 210px;
    height: auto;
    filter: drop-shadow(0 10px 22px rgba(var(--hdg-brand-primary-rgb), 0.08));
  }

  &__visual {
    position: relative;
    min-height: 100vh;
    padding: 8rem 5rem 5rem;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background:
      linear-gradient(132deg, rgba(var(--hdg-brand-primary-rgb), 0.08), rgba(var(--hdg-brand-primary-rgb), 0.025) 46%, rgba(var(--hdg-panel-rgb), 0.72)),
      var(--hdg-surface);

    &::before,
    &::after {
      position: absolute;
      content: '';
      pointer-events: none;
    }

    &::before {
      top: 8%;
      left: -18rem;
      width: 42rem;
      height: 28rem;
      border: 1px solid rgba(var(--hdg-brand-primary-rgb), 0.11);
      border-radius: 8px;
      transform: rotate(-15deg);
    }

    &::after {
      right: -14rem;
      bottom: 12%;
      width: 40rem;
      height: 16rem;
      border-radius: 8px;
      transform: rotate(-28deg);
      background: linear-gradient(90deg, rgba(var(--hdg-brand-primary-rgb), 0.105), rgba(var(--hdg-brand-primary-rgb), 0));
    }
  }

  &__visual-inner {
    position: relative;
    z-index: 1;
    width: min(720px, 88%);
  }

  &__hero-panel {
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-rows: auto auto 1fr auto;
    gap: 1.5rem;
    min-height: 520px;
    padding: 2rem;
    border: 1px solid rgba(var(--hdg-brand-primary-rgb), 0.14);
    border-radius: 8px;
    background: rgba(var(--hdg-panel-rgb), 0.88);
    box-shadow: 0 28px 70px rgba(34, 24, 28, 0.12);

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      content: '';
      background: linear-gradient(90deg, var(--hdg-brand-primary), var(--hdg-brand-primary-muted));
    }

  }

  &__hero-toolbar {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: auto 1.2fr 0.7fr auto;
    gap: 1rem;
    align-items: center;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid rgba(var(--hdg-brand-primary-rgb), 0.11);
  }

  &__hero-status {
    position: relative;
    display: grid;
    width: 3rem;
    height: 3rem;
    align-content: center;
    gap: 0.32rem;
    padding: 0.7rem 0.62rem;
    border: 1px solid rgba(var(--hdg-brand-primary-rgb), 0.18);
    border-radius: 8px;
    background: rgba(var(--hdg-brand-primary-rgb), 0.075);

    span {
      display: block;
      height: 0.28rem;
      border-radius: 999px;
      background: rgba(var(--hdg-brand-primary-rgb), 0.42);

      &:first-child {
        width: 86%;
      }

      &:nth-child(2) {
        width: 100%;
      }

      &:last-child {
        width: 62%;
      }
    }
  }

  &__hero-line {
    height: 0.75rem;
    border-radius: 4px;
    background: linear-gradient(90deg, rgba(var(--hdg-brand-primary-rgb), 0.16), rgba(var(--hdg-brand-primary-rgb), 0.055));
  }

  &__hero-dot {
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background: var(--hdg-brand-primary);
    box-shadow: 0 0 0 0.42rem rgba(var(--hdg-brand-primary-rgb), 0.08);
  }

  &__hero-metrics {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;

    span {
      display: grid;
      grid-template-rows: auto auto;
      gap: 1.05rem;
      min-height: 5.8rem;
      padding: 1.1rem;
      border: 1px solid rgba(var(--hdg-brand-primary-rgb), 0.085);
      border-radius: 6px;
      background: linear-gradient(180deg, rgba(var(--hdg-brand-primary-rgb), 0.06), rgba(var(--hdg-brand-primary-rgb), 0.018));
    }

    i,
    b {
      display: block;
      border-radius: 4px;
    }

    i {
      width: 2.6rem;
      height: 2.6rem;
      background: rgba(var(--hdg-brand-primary-rgb), 0.12);
    }

    b {
      width: 72%;
      height: 0.75rem;
      background: rgba(var(--hdg-brand-primary-rgb), 0.13);
    }
  }

  &__hero-chart {
    position: relative;
    z-index: 1;
    display: grid;
    min-height: 14rem;
    align-items: end;
    grid-template-columns: repeat(14, minmax(0, 1fr));
    gap: 0.72rem;
    padding: 1.5rem 1.25rem 1.25rem;
    border: 1px solid rgba(var(--hdg-brand-primary-rgb), 0.085);
    border-radius: 6px;
    background:
      repeating-linear-gradient(
        0deg,
        rgba(var(--hdg-brand-primary-rgb), 0.055) 0,
        rgba(var(--hdg-brand-primary-rgb), 0.055) 1px,
        transparent 1px,
        transparent 3.1rem
      ),
      rgba(var(--hdg-panel-rgb), 0.38);

    span {
      display: block;
      min-height: 28%;
      border-radius: 4px 4px 0 0;
      background: linear-gradient(180deg, rgba(var(--hdg-brand-primary-rgb), 0.36), rgba(var(--hdg-brand-primary-rgb), 0.08));

      &:nth-child(2n) {
        min-height: 48%;
      }

      &:nth-child(3n) {
        min-height: 72%;
      }

      &:nth-child(5n) {
        min-height: 58%;
      }
    }
  }

  &__hero-table {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: 1fr 1.4fr 0.9fr 0.7fr;
    gap: 0.75rem 1rem;
    padding-top: 0.25rem;

    span {
      height: 0.7rem;
      border-radius: 4px;
      background: rgba(var(--hdg-brand-primary-rgb), 0.1);

      &:nth-child(4n + 1) {
        width: 62%;
      }

      &:nth-child(4n + 3) {
        width: 78%;
      }

      &:nth-child(4n) {
        width: 54%;
        justify-self: end;
      }
    }
  }

  &__form-wrap {
    position: relative;
    min-height: 100vh;
    background: var(--hdg-panel) !important;
    box-shadow: -22px 0 56px rgba(34, 24, 28, 0.08);
  }

  &__form {
    max-width: 420px;

    &--totp {
      width: 100%;
      max-width: 640px;
    }
  }

  &__form-logo {
    display: block;
    width: 220px;
    height: auto;
    margin-bottom: 3rem;
  }

  &__title {
    color: var(--hdg-ink);
    font-size: 2rem;
    line-height: 1.2;
    letter-spacing: 0;

    &--stage {
      margin-bottom: 0.25rem;
    }
  }

  &__stage-header {
    display: grid;
    grid-template-columns: 3.25rem minmax(0, 1fr);
    gap: 1rem;
    align-items: center;
    margin-bottom: 0.75rem;
  }

  &__stage-icon {
    display: inline-flex;
    width: 3.25rem;
    height: 3.25rem;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(var(--hdg-brand-primary-rgb), 0.18);
    border-radius: 8px;
    background: rgba(var(--hdg-brand-primary-rgb), 0.08);
    color: var(--hdg-brand-primary);

    svg {
      width: 1.18rem;
      height: 1.18rem;
      stroke-width: 2.35;
    }
  }

  &__stage-copy {
    min-width: 0;
  }

  &__subtitle {
    margin-bottom: 0;
    color: var(--hdg-muted);
    font-size: 1.08rem;
    font-weight: 600;
    line-height: 1.45;
  }

  .auth-login-form {
    .form-group {
      margin-bottom: 1.35rem;
    }

    label {
      color: var(--hdg-ink);
      font-weight: 600;
    }
  }

  &__captcha {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.75rem;
    align-items: center;
    margin-bottom: 0.75rem;
  }

  &__captcha-image {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 3.75rem;
    padding: 0.35rem;
    border: 1px solid var(--hdg-border);
    border-radius: 6px;
    background: #fcf6f5;

    img {
      display: block;
      width: 100%;
      max-width: 184px;
      height: auto;
    }
  }

  &__totp {
    width: 100%;
  }

  &__totp-setup {
    display: grid;
    gap: 0.85rem;
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid var(--hdg-border);
    border-radius: 8px;
    background: rgba(var(--hdg-brand-primary-rgb), 0.035);
  }

  &__totp-qr {
    display: grid;
    gap: 0.65rem;
    justify-items: center;

    small {
      color: var(--hdg-muted);
      font-size: 0.82rem;
      font-weight: 600;
      line-height: 1.45;
      text-align: center;
    }
  }

  &__totp-qr-frame {
    width: min(12rem, 100%);
    padding: 0.55rem;
    border: 1px solid rgba(17, 24, 39, 0.1);
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 10px 30px rgba(8, 13, 34, 0.16);

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__totp-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    align-items: stretch;

    .btn {
      display: inline-flex;
      min-height: 2.75rem;
      align-items: center;
      justify-content: center;
      padding: 0.55rem 0.75rem;
      font-weight: 700;
      line-height: 1.2;
      text-align: center;
      white-space: normal;
    }
  }

  &__totp-key {
    display: grid;
    gap: 0.35rem;

    span {
      color: var(--hdg-muted);
      font-size: 0.82rem;
      font-weight: 600;
    }

    code {
      display: flex;
      width: 100%;
      min-height: 3rem;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      padding: 0.62rem 0.85rem;
      border: 1px solid var(--hdg-border);
      border-radius: 6px;
      background: var(--hdg-panel);
      color: var(--hdg-ink);
      font-family: inherit;
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.2;
      letter-spacing: 0;
      overflow-wrap: normal;
      white-space: nowrap;

      span {
        display: block;
        flex: 0 0 auto;
        line-height: 1.2;
        white-space: nowrap;
      }
    }
  }

  &__otp-inputs {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 0.45rem;
    margin-top: 1.35rem;
  }

  &__otp-input.form-control {
    height: 3.15rem;
    padding-right: 0;
    padding-left: 0;
    text-align: center;
    font-size: 1.35rem;
    font-weight: 700;
  }

  .form-control {
    height: 3rem;
    border-color: var(--hdg-border);
    border-radius: 6px;
    background-color: var(--hdg-panel);
    color: var(--hdg-body);

    &:focus {
      border-color: var(--hdg-brand-primary);
      box-shadow: 0 0 0 0.2rem rgba(var(--hdg-brand-primary-rgb), 0.12);
    }
  }

  .input-group-text {
    border-color: var(--hdg-border);
    background-color: var(--hdg-panel);
    color: var(--hdg-body);
  }

  .custom-control-label {
    color: var(--hdg-body);
  }

  .btn-primary {
    min-height: 3rem;
    border-radius: 6px;
    font-weight: 600;
    box-shadow: 0 12px 24px rgba(var(--hdg-brand-primary-rgb), 0.18);
  }
}

.dark-layout {
  .hdg-login {
    background: var(--hdg-surface);

    &__brand-img,
    &__form-logo {
      filter: drop-shadow(0 12px 28px rgba(var(--hdg-brand-primary-rgb), 0.16));
    }

    &__visual {
      background:
        linear-gradient(132deg, rgba(var(--hdg-brand-primary-emphasis-rgb), 0.105), rgba(22, 29, 49, 0.92) 48%, #111827),
        var(--hdg-surface);

      &::before {
        border-color: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.12);
      }

      &::after {
        background: linear-gradient(90deg, rgba(var(--hdg-brand-primary-emphasis-rgb), 0.14), rgba(var(--hdg-brand-primary-emphasis-rgb), 0));
      }
    }

    &__hero-panel {
      border-color: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.18);
      background: rgba(var(--hdg-panel-rgb), 0.86);
      box-shadow: 0 28px 70px rgba(0, 0, 0, 0.22);
    }

    &__hero-toolbar {
      border-color: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.13);
    }

    &__hero-line,
    &__hero-table span {
      background: linear-gradient(90deg, rgba(var(--hdg-brand-primary-emphasis-rgb), 0.18), rgba(var(--hdg-brand-primary-emphasis-rgb), 0.06));
    }

    &__hero-status {
      border-color: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.22);
      background: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.1);

      span {
        background: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.54);
      }
    }

    &__hero-dot {
      background: var(--hdg-brand-primary-emphasis);
    }

    &__hero-metrics span,
    &__hero-chart {
      border-color: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.12);
      background-color: rgba(22, 29, 49, 0.3);
    }

    &__hero-metrics i {
      background: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.14);
    }

    &__hero-metrics b {
      background: rgba(var(--hdg-brand-primary-emphasis-rgb), 0.16);
    }

    &__hero-chart span {
      background: linear-gradient(180deg, rgba(var(--hdg-brand-primary-emphasis-rgb), 0.4), rgba(var(--hdg-brand-primary-emphasis-rgb), 0.095));
    }

    &__form-wrap {
      background: var(--hdg-surface) !important;
      box-shadow: -22px 0 56px rgba(0, 0, 0, 0.2);
    }

    .form-control,
    .input-group-text {
      background-color: var(--hdg-panel);
      color: var(--hdg-body);
    }

    .form-control::placeholder {
      color: var(--hdg-muted);
    }
  }
}

@media (min-width: 992px) and (max-width: 1499.98px) {
  .hdg-login {
    &__form-wrap {
      padding: 0.25rem !important;
    }
  }
}

@media (max-width: 991.98px) {
  .hdg-login.auth-v2 {
    background:
      linear-gradient(160deg, rgba(var(--hdg-brand-primary-rgb), 0.065), transparent 58%),
      var(--hdg-panel);

    .hdg-login__brand {
      display: none !important;
    }
  }

  .hdg-login {

    &__form-wrap {
      padding-top: 4rem !important;
      padding-bottom: 4rem !important;
      background: transparent !important;
      box-shadow: none;
    }

    &__form {
      max-width: 420px;

      &--totp {
        max-width: 640px;
      }
    }

    &__form-logo {
      margin-right: auto;
      margin-left: auto;
    }
  }

  .dark-layout .hdg-login {
    background: var(--hdg-surface);

    &__form-wrap {
      background: transparent !important;
    }
  }
}

@media (max-width: 575.98px) {
  .hdg-login {
    &__form-logo {
      width: 190px;
      margin-bottom: 2.5rem;
    }

    &__title {
      font-size: 1.65rem;
    }

    &__totp-actions {
      grid-template-columns: 1fr;
    }
  }
}

</style>
